import React, {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import MemberRepo from '../../../Repo/MemberRepo'
import {Nullable} from '../../../../Common/TypeHelper'
import {CommonResponseDTO, CommonResponseStatus} from '../../../../Network/CommonResponse'
import {InvitationInfoDTO} from '../../../DTO/InvitationInfoDTO'
import BucketHeader from '../../../DTO/BucketHeader'

type MembersSignupRedirectPageProps = {
  navigator: NavigatorForMemberPage
  repo: MemberRepo
}

const MembersSignupRedirectPage: React.VFC<MembersSignupRedirectPageProps> = (
  {
    navigator,
    repo,
  },
) => {
  const {invitationId} = useParams<{ invitationId: string }>()

  useEffect(() => {
    const fetchData = async (): Promise<CommonResponseDTO<Nullable<InvitationInfoDTO>>> => {
      const memberSignupInfoDTO: CommonResponseDTO<Nullable<InvitationInfoDTO>>
        = await repo.getInvitationInfo(invitationId)

      if (memberSignupInfoDTO.status !== 'OK') {
        throw new Error(memberSignupInfoDTO.status)
      }
      return memberSignupInfoDTO
    }

    fetchData()
      .then((response: CommonResponseDTO<Nullable<InvitationInfoDTO>>) => {
        navigator.goToMembersSignupInputPage({
            mail: response.data?.mail || '',
            invitationId: invitationId,
          }, response.data?.signboard || {
          id: null,
          signupKey: '',
          shopId: '',
          logoImgUrl: '',
          signupReturnPageInfo: {url: '', name: ''},
          signupName: '',
          mailMagazineList: [],
          mainService: {name: ''} as jest.Mocked<BucketHeader>,
          freeServices: [],
        }, response.data?.paymentMethodList || [],
          response.data?.extendMetaData || [],
        )
      })
      .catch((e: Error) => {
        switch (e.message) {
          case CommonResponseStatus.NotFound:
            navigator.goToMembersInvalidUrlPage()
            break
          case CommonResponseStatus.Conflict:
            navigator.goToMembersInvalidOneTimeUrlPage()
            break
          case CommonResponseStatus.Forbidden:
            navigator.goToMembersInvalidOneTimeUrlPage()
            break
          default:
            navigator.goToMembersServerErrorPage()
        }
      })
  }, [repo, navigator, invitationId])

  return null
}

export default MembersSignupRedirectPage
